import {Component, OnInit, ViewChild} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {MatLegacyPaginator as MatPaginator} from '@angular/material/legacy-paginator';
import {MatSort} from '@angular/material/sort';
import {MatLegacyTableDataSource as MatTableDataSource} from '@angular/material/legacy-table';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject} from 'rxjs';
import {take, takeUntil} from 'rxjs/operators';
import {Objecttype, ObjecttypeCategory, ObjecttypeGroup, ObjecttypeSubgroup} from 'src/app/models/Objecttype';
import {SortService} from 'src/app/services/sort.service';
import {NewObjecttypeComponent} from './new-objecttype/new-objecttype.component';
import {SharedService} from 'src/app/services/shared.service';
import {ExcelService} from 'src/app/services/excel.service';
import {User} from 'src/app/models/User';
import {AdminService} from 'src/app/services/admin.service';
import * as _ from 'underscore';
import {ChecklistItemsLibraryItem} from 'src/app/models/Checklistitem';

@Component({
  selector: 'app-objecttypes',
  templateUrl: './objecttypes.component.html',
  styleUrls: ['./objecttypes.component.css'],
})
export class ObjecttypesComponent implements OnInit {
  objecttypes: Objecttype[];
  checklistItems: ChecklistItemsLibraryItem[];
  objectversions;
  isLoading = true;
  // projectversion: string;
  isEmpty = false;
  displayedColumns: string[] = [
    // 'id',
    'name',
    'enName',
    'category',
    'group',
    'subgroup',
    'status',
  ];
  dataSource: MatTableDataSource<Objecttype>;
  pageIndex = 0;
  pageSize = 100;
  page = 1;
  pages: number;
  numberOfObjectTypesWithoutEn = 0;
  numberOfChecklistItemsWithoutEn = 0;
  // @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  // @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  filter: string;
  FormFilter = new UntypedFormGroup({
    filter: new UntypedFormControl('', []),
  });
  // Hierarchy filter state
  categories: ObjecttypeCategory[] = [];
  groups: ObjecttypeGroup[] = [];
  subgroups: ObjecttypeSubgroup[] = [];
  selectedCategoryId = '';
  selectedGroupId = '';
  selectedSubgroupId = '';
  showDeactivated = false;
  user: User;
  private ngUnsubscribe = new Subject();

  constructor(
    private dialogNewObject: MatDialog,
    private sortservice: SortService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private sharedservice: SharedService,
    private excelservice: ExcelService,
    private adminservice: AdminService,
  ) {
    // projectservice.readProject().pipe(takeUntil(this.ngUnsubscribe)).subscribe((project) => {
    //   this.projectversion = project.objecttypeversion;
    // });
    // adminservice.getObjecttypeVersions().pipe(takeUntil(this.ngUnsubscribe)).subscribe((versions) => {
    //   this.objectversions = versions;
    // });
  }

  ngOnInit(): void {
    this.sharedservice.user
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((user) => {
        if (user != null) {
          this.user = user;
        }
      });

    this.adminservice.getCategories()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((categories) => {
        this.categories = categories;
      });
    this.adminservice.getGroups()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((groups) => {
        this.groups = groups;
      });
    this.adminservice.getSubgroups()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((subgroups) => {
        this.subgroups = subgroups;
      });

    this.adminservice.getAllChecklistitemsObs()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(checklistitems => {
        this.numberOfChecklistItemsWithoutEn = 0;
        const checklistItemsTemp = checklistitems;
        checklistItemsTemp.map(item => {
          if (!item.enText || item.enText.length === 0) {
            item.missingEn = true;
            this.numberOfChecklistItemsWithoutEn++;
            console.log(item);
          }
        });
        this.checklistItems = checklistItemsTemp;
        this.updateTable();
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }

  newObjecttype() {
    this.dialogNewObject.open(NewObjecttypeComponent, {
      backdropClass: 'blur-dialog-backdrop',
      // data: { version: this.projectversion },
    });
  }

  // onSelectionChange(version) {
  //   console.log('selection changed', version);
  //   this.projectversion = version;
  //   this.updateTable();
  // }

  downloadObjectTypesAsExcel() {
    const objecttypesToExport: Objecttype[] = JSON.parse(JSON.stringify(this.objecttypes));
    const checklistItemsToExport: any[] = [];
    for (const [index, objectType] of objecttypesToExport.entries()) {
      this.adminservice
        .getChecklistitems(objectType.id)
        .pipe(take(1))
        .subscribe((checklistitems) => {
          const checklistItemsNotNull = _.reject(checklistitems, _.isNull);
          checklistItemsNotNull.forEach(checklistItem => {
            checklistItemsToExport.push({
              objectTypeId: objectType.id,
              objectTypeName: objectType.name,
              objectTypeCategory: objectType.category.name,
              checklistItemId: checklistItem.id,
              checklistItemType: checklistItem.type.name,
              checklistItemText: checklistItem.text
            });
          });
          if (index === objecttypesToExport.length - 1) {
            this.excelservice.exportAsExcelFile(checklistItemsToExport, 'checklistitems');
          }
        });
    }
  }

  updateTable() {
    this.sharedservice.objecttypes
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((types) => {
        this.objecttypes = types;

        this.objecttypes.sort(this.sortservice.dynamicSort('name'));

        this.dataSource = new MatTableDataSource(this.objecttypes);
        this.dataSource.data = this.objecttypes;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.dataSource.filterPredicate = this.objecttypeFilterPredicate;
        // Always run the predicate so deactivated rows are hidden by default
        this.applyCompositeFilter();

        this.isLoading = false;
        if (this.objecttypes.length === 0) {
          this.isEmpty = true;
          this.displayedColumns = [];
        } else {
          this.isEmpty = false;
        }
        this.getFilterOnLoad();
        this.getPagesOnLoad();

        this.numberOfObjectTypesWithoutEn = 0;
        this.objecttypes.map(objectType => {
          if (!objectType.enName || objectType.enName.length === 0) {
            objectType.missingEn = true;
            this.numberOfObjectTypesWithoutEn++;
          }
        });
        this.objecttypes.map(type => {
          type.numberOfItemsMissingEn = 0;
          this.checklistItems.map(item => {
            if (item.parentid === type.id && (!item.enText || item.enText.length === 0)) {
              type.numberOfItemsMissingEn++;
            }
          })
        })
      });
  }

  getFilterOnLoad() {
    this.activatedRoute.queryParams
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (params) => {
        this.filter = params.filter;
        // document.getElementById('filter').nodeValue = filter;
        this.FormFilter.patchValue({
          filter: this.filter,
        });
        if (this.filter && this.filter.length > 0) {
          await this.applyFilter(null, this.filter);
        }
      });
  }

  async setFilter(filter: string) {
    if (this.objecttypes) {
      await this.applyFilter(null, filter);
    }
  }

  async applyFilter(event?: Event, value?: string) {
    let filterValue: string;
    if (event) {
      filterValue = (event.target as HTMLInputElement).value;
    } else {
      filterValue = value;
    }
    this.filter = filterValue;
    this.applyCompositeFilter();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }

    await this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {filter: filterValue},
      queryParamsHandling: 'merge',
    });
  }

  // Combines free-text, hierarchy dropdowns and the deactivated toggle into one
  // filter string consumed by objecttypeFilterPredicate.
  applyCompositeFilter() {
    if (!this.dataSource) {
      return;
    }
    this.dataSource.filter = JSON.stringify({
      text: (this.filter || '').trim().toLowerCase(),
      categoryId: this.selectedCategoryId || '',
      groupId: this.selectedGroupId || '',
      subgroupId: this.selectedSubgroupId || '',
      showDeactivated: this.showDeactivated,
    });
  }

  objecttypeFilterPredicate = (data: Objecttype, filter: string): boolean => {
    let f: any;
    try {
      f = JSON.parse(filter);
    } catch {
      f = {};
    }
    if (!f.showDeactivated && data.active === false) {
      return false;
    }
    if (f.categoryId && (!data.category || data.category.id !== f.categoryId)) {
      return false;
    }
    if (f.groupId && (!data.group || data.group.id !== f.groupId)) {
      return false;
    }
    if (f.subgroupId && (!data.subgroup || data.subgroup.id !== f.subgroupId)) {
      return false;
    }
    if (f.text) {
      const haystack = [
        data.name,
        data.enName,
        data.category && data.category.name,
        data.group && data.group.name,
        data.subgroup && data.subgroup.name,
      ].filter(Boolean).join(' ').toLowerCase();
      if (!haystack.includes(f.text)) {
        return false;
      }
    }
    return true;
  };

  // Filter dropdown options, prefixed with an "Alle" entry to clear the filter
  get filterGroups(): ObjecttypeGroup[] {
    if (!this.selectedCategoryId) {
      return [];
    }
    return this.groups.filter((g) => g.categoryid === this.selectedCategoryId);
  }

  get filterSubgroups(): ObjecttypeSubgroup[] {
    if (!this.selectedGroupId) {
      return [];
    }
    return this.subgroups.filter((s) => s.groupid === this.selectedGroupId);
  }

  onCategoryFilterChange(categoryId: string) {
    this.selectedCategoryId = categoryId || '';
    this.selectedGroupId = '';
    this.selectedSubgroupId = '';
    this.applyCompositeFilter();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onGroupFilterChange(groupId: string) {
    this.selectedGroupId = groupId || '';
    this.selectedSubgroupId = '';
    this.applyCompositeFilter();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onSubgroupFilterChange(subgroupId: string) {
    this.selectedSubgroupId = subgroupId || '';
    this.applyCompositeFilter();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  toggleShowDeactivated() {
    this.showDeactivated = !this.showDeactivated;
    this.applyCompositeFilter();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  async pageChange(page) {
    // console.log(page)
    await this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {pageIndex: page.pageIndex, pageSize: page.pageSize},
      queryParamsHandling: 'merge',
    });
    this.page = this.pageIndex + 1;
    this.pages = Math.ceil(page.length / page.pageSize);
  }

  getPagesOnLoad() {
    this.activatedRoute.queryParams
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((params) => {
        // console.log(params);
        if (params.pageIndex) {
          this.pageIndex = parseInt(params.pageIndex, 10);
          this.page = this.pageIndex + 1;
        }
        if (params.pageSize) {
          this.pageSize = params.pageSize;
        }
      });
    this.pages = Math.ceil(this.dataSource.filteredData.length / this.pageSize);
  }
}
